import React, { useState } from 'react';
import '../App.css';
import '../style.css';

interface ArticleImageLayoutProps {
  images: string[];
  className?: string;
}

const ArticleImageLayout: React.FC<ArticleImageLayoutProps> = ({
  images,
  className = ''
}) => {
  const [ratios, setRatios] = useState<Record<number, number>>({});

  if (images.length === 0) {
    return null;
  }

  const handleLoad = (index: number, e: React.SyntheticEvent<HTMLImageElement>) => {
    const img = e.currentTarget;
    if (img.naturalHeight > 0) {
      setRatios((prev) => ({ ...prev, [index]: img.naturalWidth / img.naturalHeight }));
    }
  };

  return (
    <div className={`article-image-layout ${className}`}>
      {images.map((image, index) => {
        const ratio = ratios[index] ?? 1;
        return (
          <div
            key={index}
            className="article-image-container"
            style={{ flexGrow: ratio, aspectRatio: ratio }}
          >
            <img
              src={image}
              alt={`Article image ${index + 1}`}
              className="article-image"
              onLoad={(e) => handleLoad(index, e)}
            />
          </div>
        );
      })}
    </div>
  );
};

export default ArticleImageLayout;
